import React from 'react';
import { Card, Placeholder, Table } from 'react-bootstrap';

const ReservationTableSkeleton: React.FC = () => {
    return (
        <Card className="mt-4">
            <Card.Header>
                <Card.Title>
                    <Placeholder as="span" animation="glow">
                        <Placeholder xs={5} />
                    </Placeholder>
                </Card.Title>
            </Card.Header>
            <Card.Body>
                <Table striped bordered hover responsive>
                    <thead>
                        <tr>
                            {Array.from({ length: 7 }).map((_, index) => (
                                <th key={index}>
                                    <Placeholder as="span" animation="glow">
                                        <Placeholder xs={10} />
                                    </Placeholder>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {Array.from({ length: 3 }).map((_, rowIndex) => (
                            <tr key={rowIndex}>
                                {Array.from({ length: 7 }).map((_, cellIndex) => (
                                    <td key={cellIndex}>
                                        <Placeholder as="span" animation="glow">
                                            <Placeholder xs={12} />
                                        </Placeholder>
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Card.Body>
        </Card>
    );
};

export default ReservationTableSkeleton;